import {
    ASCENT_FILTER_MAX, COLUMNS_BREAK_POINT, DEFAULT_FILTERS, DISTANCE_FILTER_MAX, MIN_PAGE_SIZE,
    NORMAL_GRID_ITEM_HEIGHT, ROUTE_TILES_PER_ROW,
} from '../settings'

import DefaultsComparator from './DefaultsComparator'
import PageSizeOptimizer from './PageSizeOptimizer'
import DistanceFilterConverter from './DistanceFilterConverter'
import RangeFilterConverter from './RangeFilterConverter'
import isMapRendered from './isMapRendered'
import scrollToHighlight from './scrollToHighlight'
import toggleMapViewInDOM from './toggleMapViewInDOM'
import setMapViewportToUserLocation from './setMapViewportToUserLocation'

export const areFiltersDefault = new DefaultsComparator(DEFAULT_FILTERS).isDefault

export const findOptimalPageSize = new PageSizeOptimizer({
    minPageSize: MIN_PAGE_SIZE,
    itemHeight: NORMAL_GRID_ITEM_HEIGHT,
    numColumnsNarrow: ROUTE_TILES_PER_ROW.narrow,
    numColumnsWide: ROUTE_TILES_PER_ROW.wide,
    columnsBreakPoint: COLUMNS_BREAK_POINT,
}).findOptimalPageSize

export const prepareDistanceForQuery = new DistanceFilterConverter(DISTANCE_FILTER_MAX).prepareForQuery

export const prepareAscentForQuery = new RangeFilterConverter(ASCENT_FILTER_MAX).prepareForQuery

export { isMapRendered, scrollToHighlight, toggleMapViewInDOM, setMapViewportToUserLocation }
